import { SystemContext } from "contexts/SystemContext";
import { useContext } from "react";

const useSystemState = () => {
  return useContext(SystemContext);
};

export default useSystemState;
